import { withAuthGuard } from '@/hoc/withAuthGuard';
import { usePageTitle } from '@/hooks/usePageTitle';
import SignupForm from '@/routes/signup/SignupForm';
import { useLocation } from 'react-router-dom';

interface TaraRegistrationState {
  registrationToken?: string;
  firstName?: string;
  lastName?: string;
  birthDate?: string;
}

const SignUpComponent = () => {
  const location = useLocation();
  const tara = (location.state as TaraRegistrationState | null) ?? {};

  usePageTitle('signUp');

  return (
    <SignupForm
      registrationToken={tara.registrationToken}
      firstName={tara.firstName}
      lastName={tara.lastName}
      birthDate={tara.birthDate}
    />
  );
};

const SignUp = withAuthGuard('loginOrSignup')(SignUpComponent);

export default SignUp;
